import React from "react";
import ReactDOM from "react-dom/client";
import { message } from "antd";
import "antd/dist/reset.css";
import "./index.css";
import App from "./App";
import { toUserErrorMessage } from "./lib/errorHandler";

// Configurar message globalmente antes de renderizar
message.config({
  top: 100,
  duration: 3,
  maxCount: 5,
  rtl: false,
  getContainer: () => document.body,
});

const originalMessageError = message.error.bind(message);
message.error = (content, ...rest) => {
  if (content && typeof content === "object" && content.content && !content.$$typeof) {
    return originalMessageError({ ...content, content: toUserErrorMessage(content.content) }, ...rest);
  }
  return originalMessageError(toUserErrorMessage(content), ...rest);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
